const tabs = document.querySelectorAll('[data-spark-tabs]')

function findValidChildren(nodes) {
  return Array.from(nodes).filter((child) => child.hasAttribute('class'))
}

Array.from(tabs).forEach((tab) => {
  const children = findValidChildren(tab.childNodes)
  const list = children[0]
  const listItems = findValidChildren(list.childNodes)
  const panels = findValidChildren(children[1].childNodes)
  // this ensures that nested style tags are filtered out
  const filteredButtons = Array.from(listItems[0].childNodes).filter((child) => child.hasAttribute('class'))
  const buttonClasses = Array.from(filteredButtons).map((b) => ({
    class: b.getAttribute('class'),
    disabled: b.getAttribute('disabled') === ''
  }))
  const activeClassName = buttonClasses.find((obj) => !obj.disabled)?.class
  const disabledClassName = buttonClasses.find((obj) => obj.disabled)?.class

  filteredButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      if (tab.dataset.sparkHydrated === 'true') {
        return
      }

      const panel = panels[index]
      button.setAttribute('disabled', '')

      const display = window.getComputedStyle(panel, null).display
      if (display === 'none') {
        panel.style.display = 'block'
        button.setAttribute('class', button.getAttribute('class')?.replace(activeClassName, disabledClassName))

        filteredButtons.forEach((b, i) => {
          if (i !== index) {
            b.removeAttribute('disabled')
            b.setAttribute('class', b.getAttribute('class')?.replace(disabledClassName, activeClassName))
          }
        })
        panels.forEach((p, i) => {
          if (i !== index) {
            p.style.display = 'none'
          }
        })
      }
    })
  })
})
